/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import { Grid, Typography } from "@mui/material";
import { ContentZoneContext } from "cms/components/context";
import { isArrayNotEmpty, isArrayEmpty } from "utils/empty-exists";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import Link from "./link";

const LinksListComponentDisplay = () => {
    
    const { component } = useContext(ContentZoneContext);
    const { links, title, settings } = component || {};
    const { style, format } = settings || {};
    const hasContent = isArrayNotEmpty(links);
    
    return (
        <Grid container className='linkListContainer'>
            {isArrayNotEmpty(links) &&
                <Fragment>
                    <Typography variant='h3'>{title}</Typography>
                    <div className='simplicity-linkList'>
                        {links.map((link, idx) => (
                            <div key={link.guid} className='simplicity-linkItem'>
                                <Link
                                    key={idx}
                                    idx={idx}
                                    link={link}
                                    style={style}
                                    format={format}
                                />
                            </div>
                        ))}
                    </div>
                </Fragment>
            }
            {isArrayEmpty(links) &&
                <EmptyContentMessage hasContent={hasContent} component={component} />
            }
        </Grid>
    );
};
LinksListComponentDisplay.displayName = "LinksListComponentDisplay";
export { LinksListComponentDisplay };
